module.exports = __webpack_public_path__ + "img/img-badge-007-off@3x.230f5180.png";